import { useParams } from 'react-router-dom';
import { ScoringProvider } from '../../Context/Scoring.context';
import Solution, { SolutionViewMode } from '../Solution/Solution.component';

export const AssessmentSampleAssessmentGroup: React.FC = () => {
  const { schoolId, rgzId, orgzId, examinerId, examinerFunction } = useParams() as {
    schoolId: string;
    rgzId: string;
    orgzId: string;
    examinerId: string;
    examinerFunction: string;
  };

  return (
    <ScoringProvider
      orgzId={orgzId}
      examinerId={examinerId}
      examinerFunction={examinerFunction}
    >
      <Solution
        mode={SolutionViewMode.assessmentSampleAssessmentGroup}
        schoolId={schoolId}
        rgzId={rgzId}
      />
    </ScoringProvider>
  );
};
